import React, {useState} from "react";
import Info_Component from "../components/info";
import PhoneFieldComponent from "../components/phone";
import InputComponent from "../../../../componennts/input";

function Phones_Section(props) {

    let symbol = props.rs;

    const data = props.data;

    return <div id={'phones_section'} className={''}>

        <div className="d-flex justify-content-between align-items-center mb-2">
            <Info_Component
                text={'"+" - додавання рядку; "-" - видалення рядку'}
            />

            <button onClick={props.handleInsertData} className={'btn btn-secondary rounded-3'}>
                +
            </button>
        </div>

        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
            <thead>
            <tr style={{ backgroundColor: '#f4f4f4', textAlign: 'left' }}>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Номер телефону</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>TG ID</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>WhatsApp</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Viber</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Теги</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Дія</th>
            </tr>
            </thead>
            <tbody>
            {data.map((social, i) => (
                <tr key={social.id}>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        <InputComponent
                            id={'id'}
                            type={'text'}
                            name={social.name}
                            // value={props.value.note}
                            // onChange={(e) => props.onChange(props.id, e, field.field)}
                            placeholder={social.url}
                            class={'form-control rounded-0 border-0 border-bottom '}
                        />
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        <InputComponent
                            id={'id'}
                            type={'text'}
                            name={social.name}
                            // value={props.value.note}
                            // onChange={(e) => props.onChange(props.id, e, field.field)}
                            placeholder={social.url}
                            class={'form-control rounded-0 border-0 border-bottom '}
                        />
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        <InputComponent
                            id={'id'}
                            type={'text'}
                            name={social.name}
                            // value={props.value.note}
                            // onChange={(e) => props.onChange(props.id, e, field.field)}
                            placeholder={social.url}
                            class={'form-control rounded-0 border-0 border-bottom '}
                        />
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        <InputComponent
                            id={'id'}
                            type={'text'}
                            name={social.name}
                            // value={props.value.note}
                            // onChange={(e) => props.onChange(props.id, e, field.field)}
                            placeholder={social.url}
                            class={'form-control rounded-0 border-0 border-bottom '}
                        />
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        <InputComponent
                            id={'id'}
                            type={'text'}
                            name={social.name}
                            // value={props.value.note}
                            // onChange={(e) => props.onChange(props.id, e, field.field)}
                            placeholder={social.url}
                            class={'form-control rounded-0 border-0 border-bottom '}
                        />
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        <button onClick={() => props.handleRemoveData(i)}
                                className={'btn btn-outline-danger rounded-3 m-1'}>
                            -
                        </button>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>

        <div id="list-phones" className={'d-none'}>
            {
                data.map((phone, i) => <div key={i} className="d-flex justify-content-between align-items-center mt-1">

                    <small className="text-muted m-1">
                        #{i + 1}
                    </small>

                    <PhoneFieldComponent
                        id={i}
                        value={phone}
                        onChange={props.handleChangeData}
                        add={props.handleInsertData}
                        placeholder={''}
                    />

                    <button onClick={() => props.handleRemoveData(i)}
                            className={'btn btn-outline-danger rounded-3 m-1'}>
                        -
                    </button>

                </div>)
            }

        </div>
    </div>
}

export default Phones_Section;
